{
  "UnifiedNavigation": "Experience Cloud에서 탐색",
  "adobeExperienceCloudNoOrgsSelect": "다른 조직 계정 선택",
  "help": "도움말",
  "profile": "프로필",
  "searchButton": "검색",
  "sidenavMenuCloseTooltip": "메뉴 닫기",
  "sidenavMenuOpenTooltip": "메뉴 열기",
  "solutionSwitcher": "다른 솔루션으로 전환",
  "toggleSideNav": "사이드 탐색 메뉴 전환"
}
